/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_DownloadInputs */

const en_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download receipt`)
};

const de_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung herunterladen`)
};

const fr_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger le reçu`)
};

const es_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar justificante`)
};

const it_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica ricevuta`)
};

const nl_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontvangstbewijs downloaden`)
};

const pl_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz potwierdzenie`)
};

const fi_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa kuitti`)
};

const da_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download kvittering`)
};

const sv_consumer_declaration_download = /** @type {(inputs: Consumer_Declaration_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ned kvitto`)
};

/**
* | output |
* | --- |
* | "Download receipt" |
*
* @param {Consumer_Declaration_DownloadInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_download = /** @type {((inputs?: Consumer_Declaration_DownloadInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_DownloadInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_download(inputs)
	if (locale === "fr") return fr_consumer_declaration_download(inputs)
	if (locale === "es") return es_consumer_declaration_download(inputs)
	if (locale === "it") return it_consumer_declaration_download(inputs)
	if (locale === "nl") return nl_consumer_declaration_download(inputs)
	if (locale === "pl") return pl_consumer_declaration_download(inputs)
	if (locale === "fi") return fi_consumer_declaration_download(inputs)
	if (locale === "da") return da_consumer_declaration_download(inputs)
	if (locale === "sv") return sv_consumer_declaration_download(inputs)
	return en_consumer_declaration_download(inputs)
});